import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  listing: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'listing' }),
}

export { paths }
